import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver/FileSaver';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';

@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

    public creboNumber: number;

    constructor(private http: HttpClient, private snackbar: SemsoSnackbarService) { }

    ngOnInit() {
    }

    public download(creboNumber: number) {
        this.http.get(`/ImportExport/export/${creboNumber}`, {
            responseType: 'blob'
        })
        .subscribe((data) => {
            saveAs(data, `crebo-${creboNumber}.xml`)
        }, error => {
            this.snackbar.error('Crebo niet gevonden');
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/crebo-tool/download/download.component.ts